/*

File handles all api calls for Spaces


*/
import { server } from '../../../core/engine/server'
import { modal } from '../../../core/utilities/modal'

import update from 'immutability-helper';

var SpacesUnitTest = Class.create({
  	initialize: function() {
        // #  Prepare our server object for data use
  		this.server = server;
	},
    /**
	*
	* Test state changes on spaces
	*
	*/
	testStateChanges: function(context) {
		var self = this;
		// prepare our data to be sent
		var url = "spaces/state/update";
		var params = context.state;
		// #  Send to server object for processing
		var data = this.server.getData(url,params,false, "PUT");
		// #  Listen to our data
		data
		.done(function(response){
			// #  Validate response
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
			} else {
                modal.showInfo("Space(s) states have been updated.", "success", "top", "center");
			}
		})
		.fail(function(e){
			modal.showInfo("Oops! Looks like something happened", "danger", "top", "center");
		});
	}
});

export let spacesUnitTest = new SpacesUnitTest();


// WEBPACK FOOTER //
// app/unittests/core/controllers/SpacesUnitTest.js